<template>
  <div
    class="el-tab-pane"
    v-if="(!lazy || loaded) || active"
    v-show="active"
    role="tabpanel"
    :aria-hidden="!active"
    :id="`pane-${paneName}`"
    :aria-labelledby="`tab-${paneName}`"
  >
    <slot></slot>
  </div>
</template>
<script>
  import store from 'public/store'
  const permissionMenus = store.getters.permission.menus
  export default {
    name: 'ElTabPane',
    componentName: 'ElTabPane',
    props: {
      label: String,
      labelContent: Function,
      name: String,
      closable: Boolean,
      disabled: Boolean,
      lazy: Boolean,
      auth: String,
    },
    data () {
      return {
        index: null,
        loaded: false,
        isDisabledAuth: false,
      }
    },
    computed: {
      isClosable () {
        return this.closable || this.$parent.closable
      },
      active () {
        const active = this.$parent.currentName === (this.name || this.index)
        if (active) {
          this.setLoaded()
        }
        return active
      },
      paneName () {
        return this.name || this.index
      }
    },
    mounted () {
      this.$parent.addPanes(this)
    },
    destroyed () {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
      this.$parent.removePanes(this)
    },
    watch: {
      label () {
        this.$parent.$forceUpdate()
      },
      // 根据权限和disabled属性动态计算isDisabledAuth来控制是否禁用，不用计算属性是避免重新登录的场景权限数据更新导致的状态变化
      auth: {
        handler(val) {
          if (val) {
            const hasPermission = permissionMenus.includes(val)
            this.isDisabledAuth = !hasPermission
          }
        },
        immediate: true
      }
    },
    methods: {
      setLoaded () {
        this.loaded = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/el-tabs/src/tab-pane.vue